import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { useSubmotive1Detail } from './hook';
import { Submotive1Data } from './data';
import { Submotive1ParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    SUBMOTIVE1_NEW,
    SUBMOTIVE1,
    SUBMOTIVE1_EDIT,
    SUBMOTIVE1_DETAIL,
} from '../../../../../routes/paths';
import { Submotive1RegisterHistory } from './registerHistory';

export const Submotive1Detail = () => {
    const {
        submotive1,
        submotive1Historical,
        showHistorical,
        setShowHistorical,
    } = useSubmotive1Detail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle submotivo 1"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={submotive1?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE1_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: SUBMOTIVE1,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: SUBMOTIVE1_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: SUBMOTIVE1_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(submotive1?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <Submotive1ParamsHistorical
                            historical={submotive1Historical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <Submotive1Data data={submotive1} />
                </LayoutModule>
            </LayoutModule>
            <Submotive1RegisterHistory submotive1={submotive1} />
        </>
    );
};
